import { render, staticRenderFns } from "./typography-title-wrap.vue?vue&type=template&id=a37b4912&scoped=true&"
import script from "./typography-title-wrap.vue?vue&type=script&lang=js&"
export * from "./typography-title-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37b4912",
  null
  
)

export default component.exports